import { render, staticRenderFns } from "./SyncAuthorizationRequest.vue?vue&type=template&id=7a138d5b&scoped=true"
import script from "./SyncAuthorizationRequest.vue?vue&type=script&lang=js"
export * from "./SyncAuthorizationRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a138d5b",
  null
  
)

export default component.exports